import { selectUser } from '../selectors/current_user.js';
import deprecated from '../deprecated.js';

const USER = 'dimension3';
const APPLICATION = 'dimension5';

/* global ga */

export function analyticsEvent(category, action, label, value) {
    return dispatch => {
        if (ga) {
            ga('send', 'event', category, action, label, value);
        }
    };
}

export const event = deprecated(analyticsEvent, `Use analyticsEvent instead`);

export function pageView(path) {
    return (dispatch, getState) => {
        if (ga) {
            const user = selectUser(getState());

            ga('set', APPLICATION, 'Engage');
            ga('set', USER, user.id);
            ga('send', 'pageview', path);
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/analytics.js